import { render, staticRenderFns } from "./notfound.vue?vue&type=template&id=b33e3ba4&scoped=true"
import script from "./notfound.vue?vue&type=script&lang=js"
export * from "./notfound.vue?vue&type=script&lang=js"
import style0 from "./notfound.vue?vue&type=style&index=0&id=b33e3ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33e3ba4",
  null
  
)

export default component.exports